import { useState } from 'react';
import './TodoItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { updateLeadTodo } from '../../utilities/api/leads';

export default function TodoItem({todo, lead, user, getLeadItem, isMobile, toggleNotifications}) {
    const descriptionLimit = 10
    const [showMoreDescription, setShowMoreDescription] = useState(false)

    const handleShowMoreDescription = () => {
        setShowMoreDescription(!showMoreDescription)
    }

    const completeTodo = async (evt) => {
        const data = {...todo, status: 'complete'}
        try {
            await updateLeadTodo(lead._id, todo._id, data)
            await getLeadItem(lead._id)
            await toggleNotifications('success', `Todo "${todo.title}" completed successfully`, '#FFFFFF')
        } catch (error) {
            console.log(error)
            await toggleNotifications('error', `Failed to complete todo "${todo.title}"`, '#FFFFFF')
        }
    }


  return (
    <tr className='TodoItem'>
        <td className='title'>{capitalizeFirstLetter(todo.title)}</td>
        <td className='description'>
            { showMoreDescription ? 
            <>
            <span>{todo.description? `${todo.description}` : '---'}</span>
            { todo.description && todo.description.length > descriptionLimit &&
            <>
            <span>&nbsp;</span>
            <span className='limitText' onClick={handleShowMoreDescription}>View Less</span>
            </>
            }
            </>
            : 
            <>
            <span>{todo.description? `${todo.description.substring(0, descriptionLimit)}`: '---'}</span>
            { todo.description && todo.description.length > descriptionLimit &&
            <>
            <span className='primaryText'>&nbsp;...</span>
            <span className='limitText' onClick={handleShowMoreDescription}>View More</span>
            </>
            }
            </>
            } 
        </td>
        <td className='createdAt'><span>{new Date(todo.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}</span></td>
        <td className='createdBy'>{capitalizeFirstLetter(todo.createdBy)}</td>
        <td className='assignee'>{capitalizeFirstLetter(todo.assignedTo)}</td>
        <td className={`todoPriority ${todo.priority}`}>
            <div className={`priorityContainer ${todo.priority}`}>
                <span className={`priorityColor ${todo.priority}`}></span>
                { todo.priority === 'low' &&
                <span className={`priorityText ${todo.priority}`}>Low</span>
                }
                { todo.priority === 'medium' &&
                <span className={`priorityText ${todo.priority}`}>Medium</span>
                }
                { todo.priority === 'high' &&
                <span className={`priorityText ${todo.priority}`}>High</span>
                }
            </div>
        </td>
        <td className='deadline'><span>{new Date(todo.deadline).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}</span></td>
        <td className={`todoStatus ${todo.status}`}>
            <div className={`statusContainer ${todo.status}`}>
                <span className={`statusColor ${todo.status}`}></span>
                { todo.status === 'inProgress' &&
                <span className={`statusText ${todo.status}`}>In Progress</span>
                }
                { todo.status === 'complete' &&
                <span className={`statusText ${todo.status}`}>Complete</span>
                }
            </div>
        </td>
        <td className='actions'>
            <div className='actionButtonContainer'>
                { (user._id === todo.createdByID || user._id === todo.assignedToID) &&
                <button className='completeButton' title='Complete Todo' onClick={completeTodo} disabled={todo.status==='complete'}>
                    <svg width='18' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" enableBackground="new 0 0 64 64" opacity={todo.status==='complete'? 0.3 : 0.8}>
                        <circle cx="32" cy="32" r="30" fill="#fff"/>
                        <path d="M32,2C15.431,2,2,15.432,2,32c0,16.568,13.432,30,30,30c16.568,0,30-13.432,30-30C62,15.432,48.568,2,32,2z M25.025,50l-0.02-0.02L24.988,50L11,35.6l7.029-7.164l6.977,7.184l21-21.619L53,21.199L25.025,50z" fill="#43a047"/>
                    </svg>
                </button>
                }
                { (user._id === todo.createdByID) &&
                <button className={`updateButton`} title='Update Todo' data-bs-toggle="modal" data-bs-target={`#updateLeadTodoModal${todo._id}`}>
                    <svg width="30" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.3924 23.4533C25.8971 23.4533 26.3076 23.8692 26.3076 24.3805C26.3076 24.8927 25.8971 25.3076 25.3924 25.3076H20.2192C19.7144 25.3076 19.3039 24.8927 19.3039 24.3805C19.3039 23.8692 19.7144 23.4533 20.2192 23.4533H25.3924ZM21.8048 9.63334L23.1411 10.6949C23.6891 11.1234 24.0544 11.6883 24.1794 12.2824C24.3236 12.9358 24.1698 13.5776 23.7372 14.1328L15.7769 24.4269C15.4116 24.8944 14.8732 25.1573 14.2963 25.1671L11.1238 25.206C10.9507 25.206 10.8065 25.0892 10.7681 24.9236L10.047 21.7974C9.92204 21.2228 10.047 20.6287 10.4123 20.171L16.0557 12.8667C16.1518 12.7498 16.3249 12.7313 16.4402 12.818L18.8149 14.7074C18.9687 14.834 19.1802 14.9022 19.4013 14.8729C19.8724 14.8145 20.1896 14.386 20.1416 13.9282C20.1127 13.6945 19.9974 13.4997 19.8435 13.3536C19.7955 13.3147 17.5362 11.5032 17.5362 11.5032C17.392 11.3864 17.3632 11.1721 17.4785 11.027L18.3726 9.86707C19.1994 8.80552 20.6415 8.70813 21.8048 9.63334Z" fill="#1A5E9B"/>
                        <rect x="1" y="1" width="33" height="33" rx="7" stroke="#1A5E9B" strokeOpacity="0.24" strokeWidth="2"/>
                    </svg>
                </button>
                }
                { (user._id === todo.createdByID) &&
                <button className={`deleteButton`} title='delete Todo' data-bs-toggle="modal" data-bs-target={`#deleteLeadTodoModal${todo._id}`} disabled={todo.status === 'complete'}>
                    <svg width="30" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" opacity={todo.status==='complete'? 0.3 : 0.8}>
                        <rect x="1" y="1" width="33" height="33" rx="7" stroke="#CA150C" strokeOpacity="0.24" strokeWidth="2"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M23.7366 15.3519C23.7366 15.0989 23.5313 14.8936 23.2783 14.8936H11.182C10.9281 14.8936 10.7237 15.0989 10.7237 15.3519C10.7237 16.2658 10.7072 17.1174 10.6916 17.9066C10.6238 21.3432 10.5788 23.6138 11.9676 25.0301C12.9539 26.0356 14.5737 26.4848 17.2201 26.4848C19.8692 26.4848 21.4917 26.0347 22.4808 25.0273C23.876 23.6046 23.832 21.3231 23.7669 17.8672C23.7522 17.089 23.7366 16.2502 23.7366 15.3519Z" fill="#CA150C"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M24.6313 11.847H20.8354C20.7978 11.2475 20.6319 10.4023 20.0351 9.71663C19.4044 8.99155 18.4603 8.62305 17.2283 8.62305C15.9972 8.62305 15.0531 8.99155 14.4224 9.71663C13.8256 10.4023 13.6588 11.2475 13.6212 11.847H9.82715C9.44765 11.847 9.13965 12.155 9.13965 12.5345C9.13965 12.914 9.44765 13.222 9.82715 13.222H24.6313C25.0108 13.222 25.3188 12.914 25.3188 12.5345C25.3188 12.155 25.0108 11.847 24.6313 11.847Z" fill="#CA150C"/>
                    </svg>
                </button>
                }
            </div>
            
        </td>
    </tr>
  )
}
